import { FONT_TITLE, FONT_COPY } from '../../constants/AppConstants';

export default class BtnPollOption extends Phaser.Group {
  constructor(game, id, imagekey, copy) {
    super(game);

    this.id = id;
    this.image = this.game.make.image(0, 0, imagekey);
    this.add(this.image);

    if (copy) {
      this.copy = this.game.make.text(0, this.image.height + 20, copy, {
        font: '25px ' + this.game.titleFontStyle,
        fill: '#0090C1',
        wordWrap: true,
        wordWrapWidth: this.image.width,
        boundsAlignH: 'center',
        boundsAlignV: 'top',
        align: 'center',
      });
      this.copy.setTextBounds(0, 0, this.image.width);
      this.add(this.copy);
    }

    this.onSelect = new Phaser.Signal();
  }

  enable(value) {
    this.image.inputEnabled = value;
    this.image.input.useHandCursor = value;
    if (value) {
      this.image.events.onInputDown.add(this.handleSelect, this);
    } else {
      this.image.events.onInputDown.remove(this.handleSelect, this);
    }
  }

  handleSelect() {
    this.onSelect.dispatch(this);
  }

  /*
  =======================================================================================================
    REVEAL RESULT
  =======================================================================================================
  */

  tweenPercentage(value) {
    // shouldn't be needed but just in case
    if (this.overlay) {
      this.overlay.destroy();
      this.overlayMask.destroy();
      this.revealTween.stop();
      this.game.tweens.remove(this.revealTween);
    }

    // store the percentage value, we use this to update text
    this.resultsValue = value;

    // create the alpha's overlay circle that sits over theimage
    this.imageOverlay = this.game.make.graphics();
    this.imageOverlay.beginFill(0xee00ee, 0.45);
    this.imageOverlay.drawCircle(this.image.width * 0.5, this.image.height * 0.5, this.image.width);
    this.add(this.imageOverlay);

    // create the overlay circle that the percentage raise will use
    this.percentageOverlay = this.game.make.graphics();
    this.percentageOverlay.beginFill(0xee00ee);
    this.percentageOverlay.drawCircle(
      this.image.width * 0.5,
      this.image.height * 0.5,
      this.image.width
    );
    this.add(this.percentageOverlay);

    // create a mask for the circle
    this.overlayMask = this.game.make.graphics();
    this.overlayMask.beginFill(0xee00ee);
    this.overlayMask.drawRect(0, 0, this.image.width, this.image.height);
    this.add(this.overlayMask);
    this.overlayMask.y = this.image.height;

    this.percentageOverlay.mask = this.overlayMask;

    // create text to display percent value
    this.textPercent = this.game.make.text(0, 0, '0%', {
      font: '60px ' + this.game.titleFontStyle,
      fill: '#FFFFFF',
      align: 'center',
      boundsAlignH: 'center',
      boundsAlignV: 'middle',
    });
    this.textPercent.setTextBounds(0, 0, this.image.width, this.image.height);
    this.textPercent.setShadow(1, 5, 'rgba(0,0,0,0.25)', 0);
    this.add(this.textPercent);

    // tween overlay mask to reveal overlay :)
    this.revealTween = this.game.add
      .tween(this.overlayMask)
      .to(
        { y: this.image.height - (this.image.height * value) / 100 },
        value * 30,
        Phaser.Easing.Quadratic.Out,
        true
      );

    // listsners
    this.revealTween.onUpdateCallback(this.handleTweenUpdate, this);
    this.revealTween.onComplete.add(this.handleRevealComplete, this);
  }

  handleTweenUpdate(a, b, c) {
    //update text according to tween value
    this.textPercent.text = this.resultsValue + '%';
  }

  handleRevealComplete() {
    this.revealTween.onComplete.remove(this.handleRevealComplete, this);
    this.revealTween.onUpdateCallback(null);
    this.textPercent.text = this.resultsValue + '%';
  }

  /*
  =======================================================================================================
    GETTERS
  =======================================================================================================
  */

  get width() {
    return this.image.width * this.scale.x;
  }

  get height() {
    return this.image.height * this.scale.y;
  }

  /*
  =======================================================================================================
    DESTROY
  =======================================================================================================
  */

  destroy() {
    this.image.destroy(true);
    if (this.overlay) {
      this.overlay.destroy(true);
      this.overlay = null;
    }
    if (this.overlayMask) {
      this.overlayMask.destroy(true);
      this.overlayMask = null;
    }
    if (this.textPercent) {
      this.textPercent.destroy(true);
      this.textPercent = null;
    }
    if (this.revealTween) {
      this.revealTween.stop();
      this.revealTween.onComplete.remove(this.handleRevealComplete, this);
      this.revealTween.onUpdateCallback(null);
      this.game.tweens.remove(this.revealTween);
      this.revealTween = null;
    }

    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/buttons/BtnPollOption.js